import { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  ArrowLeft,
  ChevronDown,
  User,
} from 'react-feather'

import { useLoginStore } from 'stores'

import {
  Wrapper,
  Title,
  ProfileButton,
  Menu,
} from './navigationStyle'

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const location = useLocation()
  const isLoggedIn = useLoginStore(state => state.isLoggedIn)
  const profileImage = useLoginStore(state => state.profileImage)
  const menuRef = useRef()
  const firstItemRef = useRef()

  useEffect(() => {
    if (isMenuOpen) firstItemRef.current?.focus()
  }, [isMenuOpen])

  const linkClicked = () => {
    setIsMenuOpen(false)
  }
  
  return (
    <Wrapper>
      <Title to="/" as={location.pathname !== '/' && Link}>
        {location.pathname !== '/' && <ArrowLeft />}
        <span>ERA</span>
      </Title>

      <ProfileButton
        type="button"
        title="Open user menu"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        id="menu_button"
      >
        {isLoggedIn ? <img src={profileImage} alt="" /> : <User size="2em" />}
        <ChevronDown />
      </ProfileButton>

      {isMenuOpen && (
        <Menu
          ref={menuRef}
          onBlur={e => {
            if (menuRef.current.contains(e.relatedTarget) || e.relatedTarget?.id === 'menu_button') return
            setIsMenuOpen(false)
          }}
        >
          <Link onClick={linkClicked} to="/settings" ref={firstItemRef}>Settings</Link>
          <Link onClick={linkClicked} to="/about">About</Link>
          {isLoggedIn ? (
            <button type="button" onClick={() => {
              linkClicked()
              window.gapi.auth2.getAuthInstance().signOut()
            }}>Log out</button>
          ) : (
            <Link onClick={linkClicked} to="/login">Log in to sync countdowns</Link>
          )}
        </Menu>
      )}
    </Wrapper>
  )
}

export default Navigation